import React from "react";
import './sidebarGenericSuggestions.css'
import LinearProgress from '@material-ui/core/LinearProgress';
class ChatBoxGenericSuggestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data.sort((a,b)=> a.keyword.S.localeCompare(b.keyword.S)),
      setMessage: props.setMessage,
      isChatLoading: props.isChatLoading,
      clickedCurrent: ""
    };
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data.sort((a,b)=> a.keyword.S.localeCompare(b.keyword.S)) })
    }
    if (prevProps.isChatLoading !== this.props.isChatLoading) {
      this.setState({ isChatLoading: this.props.isChatLoading })
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.data.length !== 0 ? (
          <React.Fragment>
            <h3 style={{ textAlign: 'center' }}>Sample Questions</h3>
            <div>
              {this.state.data.map((keyword) => {
                return (
                  <React.Fragment key={keyword.keyword.S}>
                    <div className="keyword-item" onClick={() => {
                      this.setState({clickedCurrent:keyword.keyword.S})
                    }}>
                      <h4 style={{ textAlign: 'center' }}>{this.capitalizeFirstLetter(keyword.keyword.S)}</h4>
                        <div >
                          {keyword.keyword.S === this.state.clickedCurrent && keyword.prompts.L.map((currPrompt, idx) => {
                            // Apply date modifications
                            let keywordPrompt = currPrompt.S
                            const current_year = new Date().getFullYear()
                            keywordPrompt = keywordPrompt.replace("{current_year}", current_year)
                            keywordPrompt = keywordPrompt.replace("{previous_year}", (current_year - 1).toString())

                            return (
                              <div key={idx} className="paper-template-selector" style={{backgroundColor:'#eee'}} onClick={() => {
                                // Only send if chat is not loading
                                if (!this.state.isChatLoading) {
                                  this.state.setMessage(keywordPrompt)
                                }
                              }}>
                                <p style={{ margin: 0, textAlign: 'center', textWrap: "balance" }}>{keywordPrompt}</p>
                              </div>
                            )
                          })}
                        </div>
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h3 style={{textAlign:'center'}}>Loading Sample Questions</h3>
            <LinearProgress color="primary" />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default ChatBoxGenericSuggestions;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/sidebar/sidebarGenericSuggestions/sidebarGenericSuggestions.jsx